module.exports = __webpack_public_path__ + "img/profile_box_position.1df168d1.svg";